import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion"; // ✅ Import Framer Motion
import "./Navbar.css";
import logo from "../assets/images/logo.png";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <motion.nav
      className={`navbar ${scrolled ? "scrolled" : ""}`}
      initial={{ y: -100, opacity: 0 }} // Start position (off-screen)
      animate={{ y: 0, opacity: 1 }} // Slide into view
      transition={{ duration: 1, ease: "easeOut" }} // Smooth animation
    >
      <div className="navbar-container">
        {/* ✅ Logo */}
        <div className="logo">
          <img src={logo} alt="Induratna Law" />
          <h2>InduRatna Law</h2>
        </div>

        {/* ✅ Mobile Menu Button (Text-Based) */}
        <button className="menu-button" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? "CLOSE" : "MENU"}
        </button>

        {/* ✅ Navigation Links */}
        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
          <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
          <li><Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link></li>
          <li><Link to="/services" onClick={() => setMenuOpen(false)}>Our Offering</Link></li>
          <li><Link to="/testimonial" onClick={() => setMenuOpen(false)}>Testimonials</Link></li>
          <li><Link to="contact" onClick={() => setMenuOpen(false)}>Contact Us</Link></li>
        

          {/* ✅ Consultant Now Button inside mobile menu */}
          <li className="mobile-only">
            <Link to="/contact" className="consult-button" onClick={() => setMenuOpen(false)}>
              Consult Now
            </Link>
          </li>
        </ul>

        {/* ✅ Consultant Now Button (Hidden in Mobile) */}
        <Link to="/contact" className="consult-button desktop-only">
          Consult Now
        </Link>
      </div>
    </motion.nav>
  );
}

export default Navbar;
